import { render, staticRenderFns } from "./seaBookingOverseaBill.vue?vue&type=template&id=228fe263&scoped=true&"
import script from "./seaBookingOverseaBill.vue?vue&type=script&lang=js&"
export * from "./seaBookingOverseaBill.vue?vue&type=script&lang=js&"
import style0 from "./seaBookingOverseaBill.vue?vue&type=style&index=0&id=228fe263&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228fe263",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('228fe263')) {
      api.createRecord('228fe263', component.options)
    } else {
      api.reload('228fe263', component.options)
    }
    module.hot.accept("./seaBookingOverseaBill.vue?vue&type=template&id=228fe263&scoped=true&", function () {
      api.rerender('228fe263', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/pageUICustom/seaBookingOverseaBill.vue"
export default component.exports